import { UserRole } from 'types/enums';
import { UserRoleType } from 'types/types';

export const getUserRoleTitle = (role: UserRoleType): string => {
  const [roleName] = Object.entries(UserRole).find(([_, roleId]) => roleId === role);

  return roleName.replace(/_/g, ' ').replace(/\w\S*/g, function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
};
